import { render } from "./MembersSection.vue?vue&type=template&id=07948710&scoped=true"
import script from "./MembersSection.vue?vue&type=script&lang=js"
export * from "./MembersSection.vue?vue&type=script&lang=js"

import "./MembersSection.vue?vue&type=style&index=0&id=07948710&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07948710"]])

export default __exports__